import React from 'react'
import React1 from '../../assets/react-logo.png'
import AWS from '../../assets/amazon-logo.png'
import Flutter from '../../assets/flutter-logo.png'
import Graph from '../../assets/graphQL.png'

const Saasappsection = () => {
  return (
    <div className="my-10 flex flex-col">
          <div className="font-prime text-2xl text-sec4 font-bold flex items-center justify-center mt-10">SaaS App Development</div>
            <div className="flex flex-row px-10 mt-10">
            <div className="text-6xl font-prime font-bold pr-32 w-1/2 ml-20">
                Let us add agility and speed to your business by adopting the power of cloud infrastructure.
            </div>
            <div className="flex flex-col gap-5 ml-10">
                {[
                    { text: 'Backend platform for web apps, mobile apps, and connected devices.' },
                    { text: 'Simplify existing monolithic applications to build microservices-driven software.' },
                    { text: 'Use AWS, Google Cloud, or other specialized platforms.' }
                ].map((item, index) => (
                    <div key={index} className="flex items-center">
                        <div className="bg-sec4 rounded-full w-12 h-12 flex items-center justify-center">
                            <div className="text-white font-bold text-3xl"><ion-icon name="checkmark"></ion-icon></div>
                        </div>
                        <div className="font-prime font-medium text-xl ml-5 my-5">{item.text}</div>
                    </div>
                ))}
              </div>
        </div>
        <div className="grid grid-cols-4 px-10 my-20">
            <div className="flex flex-col w-1/4 ml-10">
                  <img src={React1} alt="" className='h-[84px] w-[84px]' />
                  <div className="flex items-center font-prime font-medium text-xl mt-3 ml-2">React</div>
            </div>
            <div className="flex flex-col w-1/4 ml-20">
                  <img src={AWS} alt="" className='h-[84px] w-[84px]' />
                  <div className="flex items-center font-prime font-medium text-xl mt-3 ml-2">AWS</div>
            </div>
            <div className="flex flex-col w-1/4 ml-40">
                  <img src={Flutter} alt="" className='h-[84px] w-[84px]' />
                  <div className="flex items-center font-prime font-medium text-xl mt-3 ml-2">Flutter</div>
            </div>
            <div className="flex flex-col w-1/4 ml-80">
                  <img src={Graph} alt="" className='h-[84px] w-[84px]' />
                  <div className="flex items-center font-prime font-medium text-xl mt-3 ml-2">GraphQL</div>
            </div>
        </div>
    </div>
  )
}

export default Saasappsection
